import type { ComponentPropsWithRef } from 'react';

import { joinCn } from '../util';
import twStyle from './style';
import type { VLabelProps } from './type';

const VLabel = ({
  ref,
  required,
  disabled,
  htmlFor,
  children,
  className,
  style,
  labelClassName,
}: VLabelProps & ComponentPropsWithRef<'div'>) => {
  return (
    <div
      ref={ref}
      className={joinCn(twStyle.vLabel({ required, disabled }), className)}
      style={style}
    >
      <label
        className={joinCn('inline-block', labelClassName)}
        htmlFor={htmlFor}
      >
        {children}
      </label>
    </div>
  );
};

export default VLabel;
